import { useCallback, useMemo, useState } from 'react';
import { useConvSetting } from '@laigu/store';
import { useLocation } from 'react-router-dom';

function useStream(streams = []) {
  const { convSetting } = useConvSetting();
  const { foldSetting } = convSetting;

  // 展开的id
  const [openList, setOpenList] = useState([]);

  const onOpenFold = useCallback(
    foldId => {
      openList.push(foldId);
      setOpenList([...openList]);
    },
    [openList]
  );

  const { pathname } = useLocation();

  const newStreamList = useMemo(() => {
    // 现在只有chat才打开
    if (pathname.startsWith('/chat')) {
      const list = [];
      let foldList = [];
      streams.forEach((stream, index) => {
        const { action, type } = stream;
        if (
          action === 'message' &&
          ['welcome', 'promotion', 'guide', 'auto_reply'].includes(type) &&
          foldSetting.includes('auto_message')
        ) {
          foldList.push(stream);
          // 如果是最后一条，直接加入到折叠
          if (index === streams.length - 1) {
            list.push({ type: 'fold', children: foldList, foldId: foldList[0].id });
            foldList = [];
          }
          return;
        }
        // 折叠
        if (foldList.length) {
          // 新增的类型 fold，标识下面的部分都要被折叠
          list.push({ type: 'fold', children: foldList, foldId: foldList[0].id });
          foldList = [];
        }
        list.push(stream);
      });
      return list;
    }
    return streams;
  }, [streams, foldSetting, pathname]);

  return { streamList: newStreamList, onOpenFold, openList };
}

export default useStream;
